import React from 'react';
import { SolicitationSection } from 'pages/project';
import { ProjectEditorContextProps } from 'pages/project/ProjectEditor/contexts/types';

const Equipments: React.FC<ProjectEditorContextProps> = props => {
  return <SolicitationSection requestTable requestType="compra" {...props} />;
};

export default Equipments;
